export default __webpack_public_path__ + "static/media/sushiswap.b1f98175.svg";